import { jsx } from 'react/jsx-runtime';
import { useState, useEffect, useCallback } from 'react';
import { Button } from '../../../Button/Button.es.js';
import { Icon } from '../../../Icon/Icon.es.js';
import { useCodeSnippetContext } from '../../CodeSnippet.Context/index.es.js';

// Reset the copied icon state after 3 seconds.
const COPY_CLIPBOARD_RESET_INTERVAL = 3000;
const CodeSnippetControlsCopy = ()=>{
    const { content, locale } = useCodeSnippetContext();
    const [isCheckIconShowing, setIsCheckIconShowing] = useState(false);
    useEffect(()=>{
        // Clear the interval when the component unmounts and value was copied
        if (isCheckIconShowing) {
            const timeout = setTimeout(()=>setIsCheckIconShowing(false), COPY_CLIPBOARD_RESET_INTERVAL);
            return ()=>clearTimeout(timeout);
        }
    }, [
        isCheckIconShowing,
        setIsCheckIconShowing
    ]);
    const handleCopyToClipboard = useCallback(()=>{
        void navigator.clipboard.writeText(content);
        setIsCheckIconShowing(true);
    }, [
        content,
        setIsCheckIconShowing
    ]);
    return jsx(Button, {
        label: locale.ariaLabel,
        onClick: handleCopyToClipboard,
        size: "sm",
        variant: "primary",
        iconOnly: true,
        children: jsx(Icon, {
            name: isCheckIconShowing ? 'CheckOutline' : 'DuplicateSolid'
        })
    });
};
CodeSnippetControlsCopy.displayName = 'CodeSnippet.Controls.Copy';

export { CodeSnippetControlsCopy };
//# sourceMappingURL=CodeSnippet.Controls.Copy.es.js.map
